import seedrandom from 'seedrandom';
import {
  DICEBEAR_AVATAR_BASE_URL,
  GITHUB_OAUTH_AUTHORIZE_URL,
  GITHUB_OAUTH_CALLBACK_ROUTE,
  GITHUB_OAUTH_SCOPES,
  GITHUB_OAUTH_STATE_LOCALSTORAGE_KEY
} from '../config/constants';
import { AVATAR_COLORS } from '../config/colors';

// get link to user's dicebear avatar from username
export const getUserAvatarSrc = (username: string): string => {
  // initialize random number generator
  const rng = seedrandom(username);
  // choose random avatar colors array index
  const randomColorIndex = Math.floor(rng() * (AVATAR_COLORS.length));
  // construct dicebear avatar URL
  const avatarSrc = `${DICEBEAR_AVATAR_BASE_URL}?backgroundColor=${AVATAR_COLORS[randomColorIndex]}&seed=${username}`;

  return avatarSrc;
};

// get github oauth authorization url
export const getGitHubOAuthAuthorizationURL = (): string => {
  // generate and store random state
  const state = Math.random().toString(36).slice(2);
  localStorage.setItem(GITHUB_OAUTH_STATE_LOCALSTORAGE_KEY, state);

  // set up authorization parameters
  const params = new URLSearchParams();
  params.append('client_id', process.env.REACT_APP_SIGMOID_GITHUB_CLIENT_ID as string);
  params.append('redirect_uri', window.location.origin.toString() + GITHUB_OAUTH_CALLBACK_ROUTE);
  params.append('scope', encodeURIComponent(GITHUB_OAUTH_SCOPES.join(' ')));
  params.append('state', state);

  // return authorization url
  return GITHUB_OAUTH_AUTHORIZE_URL + '?' + params.toString();
};
